import axios from "axios";
import toast from "react-hot-toast";

const baseUrl = import.meta.env.DEV
  ? `http://localhost:3000/api`
  : import.meta.env.VITE_BASE_API_URL;

console.log(`Base url of the application ${baseUrl}`);

const AxiosInstance = axios.create({
  baseURL: baseUrl,
});

AxiosInstance.interceptors.response.use(
  (response) => response,
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // console.log({ ...error.response });
    if (
      error &&
      error.response &&
      (error.response.status === 500 || error.response.status === 400)
    ) {
      toast.error(
        `Đã có lỗi xảy ra với yêu cầu này. [Mã lỗi:  ${error.message}]`,
        {}
      );
    }

    return Promise.reject(error);
  }
);

export default AxiosInstance;
